import ResourceService from "./resource.service";

class DamageLevelService extends ResourceService {
  static get resource() {
    return "damage-level";
  }
}

export default DamageLevelService;
